import view from '../../view';
import getBlockIdsByElement from './get-block-ids-by-element';

const getBlockIdsByElementId = (elementId) =>
  getBlockIdsByElement(view.accessors.getStaticElement(elementId));

export default getBlockIdsByElementId;
